<div id="layoutDefault">
    <div id="layoutDefault_content"><div class="r-text-xl text-center primary m-5">Clearing cache & then redirecting</div></div>
    <div id="layoutDefault_footer"></div>
</div>
